// File: frontend/src/i18n/vapi-reasons.js
// Version: 1.0 (2026-10-18, Task T1)
// Description: Локализованный словарь кодов завершения звонков Vapi (endedReason).
//              Защита от обрезанных подписей ("Customer hu…") и полная поддержка EN/RU.

export const VAPI_ENDED_REASONS = {
    'customer-ended-call': {
        en: 'Customer hung up',
        ru: 'Абонент повесил трубку',
    },
    'assistant-ended-call': {
        en: 'Assistant ended call',
        ru: 'Ассистент завершил звонок',
    },
    'assistant-forwarded-call': {
        en: 'Call forwarded',
        ru: 'Звонок переведён',
    },
    'assistant-said-end-call-phrase': {
        en: 'End call phrase used',
        ru: 'Фраза прощания',
    },
    'customer-did-not-answer': {
        en: 'No answer',
        ru: 'Нет ответа',
    },
    'customer-busy': {
        en: 'Line busy',
        ru: 'Линия занята',
    },
    'customer-did-not-give-microphone-permission': {
        en: 'Microphone permission denied',
        ru: 'Микрофон заблокирован',
    },
    'silence-timed-out': {
        en: 'Silence timeout',
        ru: 'Таймаут тишины',
    },
    'max-duration-reached': {
        en: 'Max duration reached',
        ru: 'Лимит времени исчерпан',
    },
    'voicemail': {
        en: 'Voicemail reached',
        ru: 'Голосовая почта',
    },
    'phone-call-provider-closed-websocket': {
        en: 'Telephony disconnected',
        ru: 'Связь разорвана оператором',
    },
    'ring-timed-out': {
        en: 'Ringing timeout',
        ru: 'Таймаут вызова',
    },
    'twilio-failed-to-connect-call': {
        en: 'Connection failed',
        ru: 'Сбой подключения',
    },
    'pipeline-error-vapi-400': {
        en: 'Vapi error (400)',
        ru: 'Ошибка Vapi (400)',
    },
    'pipeline-error-vapi-500': {
        en: 'Vapi server error (500)',
        ru: 'Ошибка сервера Vapi (500)',
    },
    'pipeline-error-openai-400': {
        en: 'OpenAI error (400)',
        ru: 'Ошибка OpenAI (400)',
    },
    'pipeline-error-openai-500': {
        en: 'OpenAI server error (500)',
        ru: 'Ошибка OpenAI (500)',
    },
    'pipeline-error-azure-400': {
        en: 'Azure error (400)',
        ru: 'Ошибка Azure (400)',
    },
    'pipeline-error-azure-500': {
        en: 'Azure server error (500)',
        ru: 'Ошибка Azure (500)',
    },
    'pipeline-error-deepgram-400': {
        en: 'Deepgram error (400)',
        ru: 'Ошибка Deepgram (400)',
    },
    'pipeline-error-deepgram-500': {
        en: 'Deepgram server error (500)',
        ru: 'Ошибка Deepgram (500)',
    },
    'pipeline-error-eleven-labs-400': {
        en: 'ElevenLabs error (400)',
        ru: 'Ошибка ElevenLabs (400)',
    },
    'pipeline-error-eleven-labs-500': {
        en: 'ElevenLabs server error (500)',
        ru: 'Ошибка ElevenLabs (500)',
    },
    'unknown-error': {
        en: 'Unknown error',
        ru: 'Неизвестная ошибка',
    },
};

/**
 * Преобразует код endedReason от Vapi в человекочитаемую строку на выбранном языке.
 * Гарантирует отсутствие уродливых обрезаний ("Customer hu…") и чистое форматирование
 * неизвестных кодов без потери смысла.
 *
 * @param {string|null|undefined} reason
 * @param {string} [lang='en']
 * @returns {string}
 */
export function formatVapiEndedReason(reason, lang = 'en') {
    if (!reason || reason === 'None' || reason === '-' || reason === 'null' || reason === 'undefined') {
        return '—';
    }

    const normalizedLang = lang === 'ru' ? 'ru' : 'en';

    if (Object.prototype.hasOwnProperty.call(VAPI_ENDED_REASONS, reason)) {
        return VAPI_ENDED_REASONS[reason][normalizedLang] || VAPI_ENDED_REASONS[reason].en;
    }

    // Если код неизвестен словарю — разбиваем по дефисам/подчёркиваниям
    // и делаем аккуратный Title Case без обрезания подстроки.
    return reason
        .split(/[-_]+/)
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}

export default formatVapiEndedReason;
